module.exports = __webpack_public_path__ + "img/37200.f3155aaa.jpg";